import { localStorage } from 'dibs-browser-storage';
import { RECENT_SEARCHES } from './nftSearchBarConstants';
import { type SuggestionType, type TermType, type CursorType } from './nftSearchBarConstants';

export const createSearchLink = (term: string, urlLabel?: string, type?: string): string => {
    const convertedValue = encodeURIComponent(term.toLowerCase());
    let href;

    if (urlLabel && type !== RECENT_SEARCHES.TYPE) {
        href = urlLabel;
    } else {
        href = `nft-collections/search/?q=${convertedValue}`;
    }

    return href;
};

export const getCursorTerms = (data: SuggestionType[], currentValue: string): CursorType[] => {
    const terms: CursorType[] = [];
    data.forEach(suggestion => {
        suggestion.terms?.forEach((item, index) => {
            const { type } = suggestion;
            const { term, urlLabel } = item;
            terms.push({
                term: term || '',
                highlightId: `${term}-${type}-${index}`,
                link: createSearchLink(term || '', urlLabel, type),
            });
        });
    });
    terms.push({ term: currentValue, highlightId: `${currentValue}-USER_INPUT` });
    return terms;
};

export const dedupeLocalStorage = (): SuggestionType[] | undefined => {
    const storageData = (localStorage.getItem(RECENT_SEARCHES.LOCAL_STORAGE) ||
        []) as SuggestionType[];
    const dedupeData: SuggestionType[] = [];

    storageData.forEach((section, index) => {
        const terms: { [key: string]: boolean } = {};
        dedupeData.push({ type: section.type, terms: [] });
        section.terms?.forEach(termObj => {
            if (termObj.term) {
                if (!terms[termObj.term]) {
                    terms[termObj.term] = true;
                    dedupeData[index]?.terms?.push(termObj);
                }
            }
        });
    });
    return dedupeData.length ? dedupeData : undefined;
};

export const handleRecentStorage = (term: string, urlLabel: string): void => {
    if (!urlLabel.includes('nft-collections/search/')) {
        return;
    }
    const search = { term, urlLabel };
    let localRecentSearches = (localStorage.getItem(RECENT_SEARCHES.LOCAL_STORAGE) ||
        []) as SuggestionType[];
    let recentTerms: TermType[] = [];

    if (!localRecentSearches.length) {
        localRecentSearches = [
            {
                type: RECENT_SEARCHES.TYPE,
                terms: [search],
            },
        ];
    } else {
        recentTerms = localRecentSearches[0].terms || [];
        if (recentTerms.length === RECENT_SEARCHES.MAX_TERMS) {
            recentTerms.pop();
        }
        recentTerms.unshift(search);
    }

    localStorage.setItem(RECENT_SEARCHES.LOCAL_STORAGE, JSON.stringify(localRecentSearches));
};

export const cleanUpRecentSearches = (): void => {
    const storageData = (localStorage.getItem(RECENT_SEARCHES.LOCAL_STORAGE) ||
        []) as SuggestionType[];
    const cleanedRecentSearches = storageData.reduce(
        (cleanedStorageData: SuggestionType[], section: SuggestionType) => {
            if (section.type && Array.isArray(section.terms)) {
                section.terms = section.terms.filter(termObj => termObj.term && termObj.urlLabel);
                return [...cleanedStorageData, section];
            }
            return cleanedStorageData;
        },
        []
    );
    localStorage.setItem(RECENT_SEARCHES.LOCAL_STORAGE, JSON.stringify(cleanedRecentSearches));
};
